import { Button } from '../button'

const amountOptions = {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
}

export default function ConfirmAccept({ amount, onBack, onAccept }) {
  return (
    <div className='confirmAccept flex flexDirectionColumn alignCenter'>
      <h2>Accept Offer</h2>
      <p className='acceptingAmount'>
        You are accepting <span>{Number(amount).toLocaleString('en-US', amountOptions)}</span> price
        for this vehicle.
      </p>
      <p className='note'>You can counter offer from the offers screen.</p>
      <div className='buttonsContainer flex justifyCenter'>
        <Button color='secondary' onClick={onBack}>
          Back
        </Button>
        <Button onClick={onAccept}>Accept</Button>
      </div>

      <style jsx>{`
        .confirmAccept {
          width: 100%;
          height: 100%;
          justify-content: center;
        }

        h2 {
          font-size: 3.2rem;
        }

        p {
          font-size: 1.6rem;
        }

        .acceptingAmount {
          margin: 1.26rem 0 2.3rem;

          span {
            color: var(--primary-color);
          }
        }

        .note {
          color: var(--secondary-text-color);
          font-weight: 700;
        }

        .buttonsContainer {
          max-width: 39.8rem;
          width: 100%;
          margin: 2rem 0 0;

          :global(button) {
            width: 19.1rem;
            margin: 0 0.8rem;
          }
        }

        @media (max-width: 1024px) {
          .confirmAccept {
            justify-content: flex-start;
          }

          h2 {
            margin-top: 1.5rem;
            font-size: 1.8rem;
          }

          p {
            font-size: 1.4rem;
          }

          .acceptingAmount {
            margin: 0.5rem 0 1rem;
          }

          .buttonsContainer {
            position: fixed;
            left: 0;
            bottom: 2.1rem;
            z-index: 1;
            width: 100%;
            margin: 0;
            padding: 0 1.3rem;

            :global(button) {
              width: 100%;
            }
          }
        }
      `}</style>
    </div>
  )
}
